module.exports = __webpack_public_path__ + "img/13.78978992.png";